module.exports = __webpack_public_path__ + "img/my.e1e99376.svg";